import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {
    FIELD_LIST_INPUT_GENERAL_RACE_CATEGORY,
    FIELD_LIST_INPUT_RACE_CATEGORY_ITEM, FIELD_NAME_INPUT_GENERAL_RACE_CATEGORY,
} from "../../../utils/input-field-list-static-page";
import {
    setAvoskinTrailRunErrorMessage,
    setAvoskinTrailRunRaceCategoryDetail
} from "../../../reducers/avoksin-trail-run.reducer";
import {convertErrorMessage, randomCode} from "../../../utils/general-variable";
import {cloneDeep} from "lodash";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../../reducers/tools.reducer";
import React, {useEffect} from "react";
import FormItemComponent from "../../../components/static-page/form-item.component";
import Item from "../race-category/item";

const RaceCategory = () => {
    const dispatch = useDispatch()
    const {raceCategoryDetail, avoskinTrailRunErrorMessage} = useSelector(state => state.avoskinTrailRunReducer)
    const {fetching: getRaceCategory} = useFetch(API.AVOSKIN_TRAIL_RUN_GET_RACE_CATEGORY)
    const {fetching: updateRaceCategory, isLoading} = useFetch(API.AVOSKIN_TRAIL_RUN_UPDATE_RACE_CATEGORY)
    const itemList = [...raceCategoryDetail.facilities]
    let fieldListGeneral = FIELD_LIST_INPUT_GENERAL_RACE_CATEGORY
    let fieldListItem = FIELD_LIST_INPUT_RACE_CATEGORY_ITEM
    let showRaceCategory = {
        label: 'Race Category',
        key: 'show_race_category',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAvoskinTrailRunRaceCategoryDetail({[key]: value}))
    }

    const addItemHandler = () => {
        itemList.push({
            id: randomCode(5, 1, 'facilities').toString(),
            title: null,
            image_url: null
        })
        dispatch(setAvoskinTrailRunRaceCategoryDetail({facilities: itemList}))
    }

    const itemListConstruct = () => {
        const itemListCopy = cloneDeep(raceCategoryDetail.facilities)
        const result = itemListCopy?.map((item, index) => {
            if(!Number(item.id)) delete item.id
            item.sequence = index
            return item
        })
        return result
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const dataItemList = itemListConstruct()
        const dataRaceCategory = {...raceCategoryDetail, facilities: dataItemList}
        updateRaceCategory(dataRaceCategory).then(response => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Race Category Updated'))
            dispatch(setAvoskinTrailRunRaceCategoryDetail({...response?.data, delete_ids: []}))
        }).catch(err => {
            dispatch(setAvoskinTrailRunErrorMessage(convertErrorMessage(err, {}, FIELD_NAME_INPUT_GENERAL_RACE_CATEGORY)))
        })
    }

    useEffect(() => {
        getRaceCategory().then(response => {
            if (response?.data?.facilities?.length > 0) {
                dispatch(setAvoskinTrailRunRaceCategoryDetail({...response?.data, delete_ids: []}))
            } else {
                const data = response?.data
                delete data?.facilities
                dispatch(setAvoskinTrailRunRaceCategoryDetail({...data, delete_ids: []}))
            }
        })

        return () => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
        }
    }, [])

    return (
        <FormItemComponent
            data={raceCategoryDetail}
            switchToggleField={showRaceCategory}
            fieldListGeneral={fieldListGeneral}
            itemList={itemList}
            content={(index) => <Item fieldList={fieldListItem} index={index}/>}
            onChange={onChange}
            setDataList={setAvoskinTrailRunRaceCategoryDetail}
            deleteList={raceCategoryDetail.delete_ids}
            objectName={'facilities'}
            addItemHandler={addItemHandler}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={avoskinTrailRunErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default RaceCategory
